import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useReachOutExperience } from "./ReachOutHook";

const ReachOutContext = createContext({});

export const ReachOutContextProvider = ({ children }) => {
    const hook = useReachOutExperience();

    const context = useMemo(
        () => ({
            ...hook
        }),
        [hook.isReachOutMode, hook.reachOutMessage]
    );

    return <ReachOutContext.Provider value={context}>{children}</ReachOutContext.Provider>;
};

export const useReachOutContext = () => {
    return useContext(ReachOutContext);
};

ReachOutContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};
